import React from "react";

import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";

const SearchInput = (props) => {
  console.log(props)
  return (
    <div className="search" style={{
      boxShadow: '2px 2px 22px -4px rgba(0,0,0,0.75)'
    }}>
        <div className='search_icon'>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Поиск…"
          className="search_input"
          value={props.search}
          onChange={props.onChange}
        />
    </div>
  );
};

export default SearchInput;
